import { useCallback } from 'react';
import { City } from 'utils/constants/location_legacy';

const DEFAULT_BOUNDING_BOX = {
  CALGARY: '50.861664,-114.341365,51.201939,-113.771449',
  TORONTO: '43.281437,-80.069846,44.148939,-78.891562',
  VANCOUVER: '49.059918,-123.398094,49.431965,-122.834358',
  EDMONTON: '53.358092,-113.779972,53.696869,-113.207997',
  AUSTIN: '30.092115,-97.941251,30.509495,-97.545723',
  LOS_ANGELES: '33.64389,-119.054651,34.637274,-117.788477',
  SAN_ANTONIO: '28.915932,-99.09352,29.898114,-98.196761',
  SAN_FRANCISCO: '37.730084,-122.475986,37.804538,-122.372899',
  HOUSTON: '29.406867,-96.357784,30.415089,-94.915829',
  DALLAS: '32.586086,-96.567050,33.023936,-97.014351',
};

export function useMapBounds() {
  const getDefaultBoundingBox = useCallback(
    (currentCity: string) => {
      switch (currentCity) {
        case City.TORONTO:
          return DEFAULT_BOUNDING_BOX.TORONTO;
        case City.VANCOUVER:
          return DEFAULT_BOUNDING_BOX.VANCOUVER;
        case City.EDMONTON:
          return DEFAULT_BOUNDING_BOX.EDMONTON;
        case City.AUSTIN:
          return DEFAULT_BOUNDING_BOX.AUSTIN;
        case City.LOS_ANGELES:
          return DEFAULT_BOUNDING_BOX.LOS_ANGELES;
        case City.SAN_ANTONIO:
          return DEFAULT_BOUNDING_BOX.SAN_ANTONIO;
        case City.SAN_FRANCISCO:
          return DEFAULT_BOUNDING_BOX.SAN_FRANCISCO;
        case City.HOUSTON:
          return DEFAULT_BOUNDING_BOX.HOUSTON;
        case City.DALLAS:
          return DEFAULT_BOUNDING_BOX.DALLAS;
        case City.CALGARY:
        default:
          return DEFAULT_BOUNDING_BOX.CALGARY;
      }
    },
    [City, DEFAULT_BOUNDING_BOX],
  );

  return {
    getDefaultBoundingBox,
  };
}
